import { createFileRoute } from '@tanstack/react-router';
import { PrintShell, PrintSong } from '@/components/ui/cifras/print-sheet';
import { Content } from '@/components/ui/content';
import { useRouter } from '@/hooks/use-router';
import { meta } from '@/lib/meta';
import { useSetlist } from '@/services/setlists';

export const Route = createFileRoute('/_app/setlists/$id/print')({
  head: () => meta({ label: 'Imprimir repertório' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const router = useRouter();
  const { data } = useSetlist(id);

  return (
    <Content
      isLoading={!data}
      breadcrumbs={{
        icon: 'printer',
        title: data?.name ?? 'Imprimir',
        items: [
          { label: 'Repertórios', route: '/setlists' },
          { label: 'Impressão', active: true },
        ],
      }}
    >
      <PrintShell onBack={() => router.back()}>
        {(options) =>
          // uma música por página, com cabeçalho "nº · título · tom"
          data?.items.map((item, index) => (
            <PrintSong
              {...options}
              key={item.id}
              number={index + 1}
              song={{
                id: item.song.id,
                title: item.song.title,
                originalKey: item.song.originalKey,
                capo: item.song.capo,
                notes: item.song.notes,
                content: item.song.content,
                artist: item.artist?.name ?? null,
                key: item.key,
              }}
            />
          ))
        }
      </PrintShell>
    </Content>
  );
}
